// extracted by mini-css-extract-plugin
export default {"container":"Up-z","bubbleNav":"Vp-z","graphic":"Wp-z","contact":"Xp-z"};